// Types.
import FilterOption from '../types/instance/FilterOption';

// Components.
import FilterDropdown from './FilterDropdown';

// Helpers.
import { getParameter, getFilterOptions, getTimeZone }
	from '../helpers/utils';

// Constants.
import { PERIOD_CUSTOM } from './Constants';
import Filter from "../types/Filter";
import * as dayjs from "dayjs";
import * as utc from 'dayjs/plugin/utc';
import * as timezone from 'dayjs/plugin/timezone';
import { useTimeRange } from "../context/TimeRangeContext";

// Extend dayjs with plugins
dayjs.extend(utc.default);
dayjs.extend(timezone.default);

export default function FilterListButton (props: { setFilterOptions?: Function })
{
	const { applyPeriod } = useTimeRange();
	const { setFilterOptions } = props;
	const timezone = getTimeZone()

	function applyFilter (snapshot: Filter): void
	{
		const parameters = snapshot.parameters
		// Convert API parameters to UI parameters.
		// TODO Consider common parameter representation.
		// Would have liked to use a link but it does not change the date e.g.
		// <Link to={makeLink (item.parameters)} ... >{item.name}</Link>
		// Links are pseudo-links: the address bar changes but App.tsx is not
		// revisited from the beginning. Instead the current page is re-rendered
		// with the existing time range.
		// Would also have had to specify the interval.
		// Change the state instead. Would appear to be order sensitive:
		// apply the time period and filter options in a single call.
		const from: string | null = getParameter (parameters, 'from');
		const to: string | null = getParameter (parameters, 'to');
		const tz: string | null = getParameter (parameters, 'tz');

		// Convert dates from snapshot timezone to user's selected timezone
		// If snapshot has a timezone, use it for conversion, otherwise use UTC
		const snapshotTimezone = tz || 'UTC';

		// First parse the dates in their original timezone
		let fromDate = from ? dayjs.tz(from, snapshotTimezone) : dayjs.default();
		let toDate = to ? dayjs.tz(to, snapshotTimezone) : dayjs.default();

		// Then convert to the user's selected timezone
		let updatedFrom = fromDate.tz(timezone);
		let updatedTo = toDate.tz(timezone);

		const options: FilterOption[] = getFilterOptions (parameters);
		applyPeriod (PERIOD_CUSTOM, updatedFrom, updatedTo, timezone, false);
		
		// Then apply the filter options separately if setFilterOptions is available
		if (setFilterOptions) {
			setFilterOptions(options);
		}
	}

	return (
			<FilterDropdown filterId="filter" dropdownId="filterDropdown" dataTip="Choose snapshot" applyFilter={applyFilter} />
	);
}
